
import { apiMediaURL, getRasterImage } from "@/lib/api";
import ParcelPlaceholder from "@/components/Parcel/ParcelPlaceholder.vue";
import { Component, MixedVue, mixins } from "@/vue";
import { propsInstance } from "@/lib/util";
import { CSSProperties } from "@vue/runtime-dom";
import { Parcel } from "@/lib/types/Parcel";
import { RasterKind } from "@/lib/types/Raster";
import { PropType } from "vue";

interface ParcelThumbnailProps {
  placeholderClass?: string;
  parcel: Parcel;
  zoomLevel?: number | "none";
  showMissingNotice?: boolean;
  kind?: RasterKind;
  /**
   * Used for lazy loading the thumbnail.
   */
  loadImage?: boolean;
}

const Props = propsInstance<ParcelThumbnailProps>({
  placeholderClass: { type: String, default: "" },
  parcel: { type: Object, required: true },
  zoomLevel: { type: [Number, String] as PropType<number | "none">, required: false, default: 15 },
  showMissingNotice: { type: Boolean, required: false, default: false },
  kind: { type: String as any, required: false, default: null },
  loadImage: { type: Boolean, default: true, required: false },
});
@Component({
  name: "ParcelThumbnail",
  components: { ParcelPlaceholder },
})
export default class ParcelThumbnail extends mixins(MixedVue, Props) {
  static components: {
    ParcelPlaceholder: typeof ParcelPlaceholder;
  };

  imageStyle: CSSProperties = {
    "min-width": "auto",
    "max-width": "auto",
    "min-height": "auto",
    "max-height": "auto",
  };

  get rasterSrc() {
    return getRasterImage(this.displayRaster, this.zoomLevel);
  }

  get kindToDisplay() {
    return this.kind || this.$store.getters.rasterKind;
  }

  get displayRaster() {
    if (!this.parcel.rasters) return null;
    return this.parcel.rasters?.find((raster) => raster?.kind === this.kindToDisplay);
  }

  get placeholderSrc() {
    return apiMediaURL(this.parcel.svg_url);
  }

  updatePlaceholderStyle() {
    const el = this.$el.querySelector(".parcel-placeholder");
    if (!el) return;
    const bounds = el.getBoundingClientRect();
    const realWidth = bounds.width + "px";
    const realHeight = bounds.height + "px";

    this.imageStyle["min-width"] = realWidth;
    this.imageStyle["max-width"] = realWidth;
    this.imageStyle["min-height"] = realHeight;
    this.imageStyle["max-height"] = realHeight;
    this.$emit("load");
  }
}
